export default __webpack_public_path__ + "static/media/slide1.d0c3acd8.jpg";